import React from 'react';
import moment from 'moment';
import { Row, Col, List, Dropdown, Menu } from 'antd';

import DownloadFlatIcon from 'components/Icons/DownloadFlatIcon';
import DropdownIcon from 'components/Icons/DropdownIcon';

import './BillingInfo.scss';

const Skeleton = (props) => <div className="skelton" {...props}></div>;
const cols = [
  { xs: 5, md: 4, xl: 4 },
  { xs: 9, md: 9, xl: 12 },
  { xs: 5, md: 4, xl: 3 },
  { xs: 5, md: 7, xl: 5 },
];

const BillingInfo = ({ loadingInvoices, invoices, invoiceLanguage }) => {
  const itemRender = (_, type, originalElement) => {
    if (type === 'prev') {
      return <a>Previous</a>;
    }
    if (type === 'next') {
      return <a>Next</a>;
    }
    return originalElement;
  };

  const renderInvoiceListItem = (date, description, amount, button) => (
    <Row className="billing-list-item item" justify="middle" align="top" gutter={8}>
      <Col {...cols[0]} className="value">
        {date}
      </Col>
      <Col {...cols[1]} className="value description">
        {description}
      </Col>
      <Col {...cols[2]} className="value">
        {amount}
      </Col>
      <Col {...cols[3]} className="invoice-value value">
        {button}
      </Col>
    </Row>
  );

  const downloadMenu = (invoice) => (
    <Menu
      className="download-invoice-menu"
      onClick={(event) => window.open(invoice.url[event.key])}>
      <Menu.Item key="he">Download in Hebrew</Menu.Item>
    </Menu>
  );

  return (
    <Row className="billing-info">
      <h2 className="plans-content-header">Billing History</h2>

      <div className="billing-table-wrapper">
        <Row className="billing-list-header" justify="middle" align="top" gutter={8}>
          <Col {...cols[0]} className="header-value">
            Date
          </Col>
          <Col {...cols[1]} className="header-value">
            Name
          </Col>
          <Col {...cols[2]} className="header-value">
            Amount
          </Col>
          <Col {...cols[3]} className="header-value invoice-header-value">
            <span className="above-md">Invoice</span>
          </Col>
        </Row>

        <List
          itemLayout="vertical"
          size="large"
          pagination={{
            onChange: (page) => {
              console.log(page);
            },
            pageSize: 6,
            itemRender: itemRender,
          }}
          dataSource={invoices?.fetchUserInvoices || []}
          renderItem={(invoice) => (
            <List.Item>
              {!loadingInvoices
                ? renderInvoiceListItem(
                    moment(new Date(invoice.documentDate)).format('MM/DD/YYYY'),
                    invoice.description,
                    `$${invoice.amount}`,
                    <Dropdown.Button
                      trigger={['click', 'hover']}
                      onClick={() => window.open(invoice.url.en || invoice.url.he)}
                      overlay={() =>
                        invoiceLanguage === 'he' && invoice.url.en ? downloadMenu(invoice) : ''
                      }
                      icon={invoiceLanguage !== 'he' ? null : <DropdownIcon />}>
                      <DownloadFlatIcon /> <span className="above-md">Download</span>
                    </Dropdown.Button>
                  )
                : renderInvoiceListItem(<Skeleton />, <Skeleton />, <Skeleton />, <Skeleton />)}
            </List.Item>
          )}
        />
      </div>
    </Row>
  );
};

export default BillingInfo;
